import { observable, action, makeObservable } from 'mobx';
import { EmailChangeFormState } from './EmailChangeFormState';
import { UserInfoApis } from '../../../../mainv3/apis/user_info';
import { FliptKeysApis } from '../../../../mainv3/apis/fliptKeys';
import { GlobalStatesV3 } from '../../../../commonv3/states/GlobalStatesV3';

export class EmailChangePageState {
  formState: EmailChangeFormState = new EmailChangeFormState();
  submitting = false;
  showCommunityEvents = false;

  constructor() {
    makeObservable(this, {
      formState: observable,
      submitting: observable,
      showCommunityEvents: observable,
      submit: action.bound,
    });
  }

  init() {
    this.loadFliptKeys();
    if (GlobalStatesV3.currentUser.isSignedIn()) {
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      this.formState.fields!.email.setValue(GlobalStatesV3.currentUser.currentUser.email);
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      this.formState.fields!.receive_promotion_emails.setValue(
        GlobalStatesV3.currentUser.currentUser.user_preference.receive_promotion_emails || false
      );
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      this.formState.fields!.receive_notification_emails.setValue(
        GlobalStatesV3.currentUser.currentUser.user_preference.receive_notification_emails || false
      );
    }
  }

  private async loadFliptKeys() {
    try {
      const response = await FliptKeysApis.find();
      this.showCommunityEvents = response.enabled_flag_keys.includes('show_community_events');
    } catch {
      // フラグ取得に失敗した場合は旧名称のまま表示する
    }
  }

  async submit() {
    this.submitting = true;
    try {
      this.formState.clearErrors();
      try {
        await UserInfoApis.updateEmail(this.formState.asJson());
      } catch (error) {
        this.formState.setErrors(error.body);
      }
      GlobalStatesV3.currentUser.reloadUser();
    } finally {
      this.submitting = false;
    }
  }
}
